<mat-table #table [dataSource]="dataSource" class="mat-elevation-z2 table-field" cdkDropList
    [cdkDropListData]="dataSource" (cdkDropListDropped)="dropTable($event)">
    <ng-container *ngFor="let column of columns; let i = index" [matColumnDef]="column.key">
        <mat-header-cell *matHeaderCellDef (mousedown)="onResizeColumn($event, i)" [style.width.px]="column.width">
            <ng-container *ngIf="column.key !== 'add'; else addColumnHeader">
                {{ column.field | translate }}
            </ng-container>
            <ng-template #addColumnHeader>
                <button mat-icon-button (click)="rowAdd()">
                    <mat-icon class="green-icon">add</mat-icon>
                </button>
            </ng-template>
        </mat-header-cell>
        <mat-cell *matCellDef="let row; let i = index" class="no-underline" [style.width.px]="column.width">
            <div *ngIf="column.key !== 'add'; else addColumn" class="cell-wrapper">
                <app-dynamic-form-control [style.width]="'100%'" [control]="row[column.key]"
                    [form]="form.controls[tableKey].controls[i]" [rowIndex]="i"
                    (boundingBoxesDisplay)="displayBoundingBox($event)"
                    (mousedown)="preventDrag($event)" (mousemove)="preventDrag($event)">
                </app-dynamic-form-control>
            </div>
            <ng-template #addColumn>
                <button mat-icon-button (click)="rowRemove(i)">
                    <mat-icon class="red-icon">remove</mat-icon>
                </button>
            </ng-template>
        </mat-cell>
    </ng-container>
    <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
    <mat-row *matRowDef="let row; columns: displayedColumns;" cdkDragBoundary=".table-field" cdkDrag
        [cdkDragData]="row" cdkDragLockAxis="y"></mat-row>
</mat-table>
